import ReactDOM from 'react-dom/client';
import { Providers } from '@/providers/index';
import './styles.css';
import { AppRouterProvider } from './providers/RouterProvider';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://9cf750be2bf6c5c36508bb96e1cfa2e1@o4510147544350720.ingest.us.sentry.io/4510147564011520',
  sendDefaultPii: false,
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_ENVIRONMENT !== 'local',
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Providers>
      <AppRouterProvider />
    </Providers>,
  );
}
